import { useDeploymentInfo } from '~/config/useDeploymentInfo';
import { cn } from '~/common/utils/styleUtil';

export function FooterDeploymentInfo() {
  const { ARTIFACT_VERSION, ARTIFACT_CREATED, ARTIFACT_REVISION, DEPLOYMENT_ENVIRONMENT } = useDeploymentInfo();
  return (
    <ul className={'flex gap-8 mt-8'}>
      <li className={cn('py-2 hover:text-primary')}>{ARTIFACT_VERSION}</li>
      <li style={{ display: 'none' }}>{ARTIFACT_CREATED}</li>
      <li style={{ display: 'none' }}>{ARTIFACT_REVISION}</li>
      <li style={{ display: 'none' }}>{DEPLOYMENT_ENVIRONMENT}</li>
    </ul>
  );
}
